import { useNavigate } from "react-router-dom";
import { useToast } from "@chakra-ui/react";
import { useAuth } from "../context/AuthContext";
import { isFundInvestmentEnabled } from "../components/funds/fundCardUtils";

export const useFundInvestNavigation = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const { isAuthenticated } = useAuth();

  return (fundRegisterCode: string) => {
    if (!isFundInvestmentEnabled(fundRegisterCode)) {
      toast({
        title: "سرمایه‌گذاری غیرفعال است",
        description: "در حال حاضر امکان سرمایه‌گذاری برای این صندوق وجود ندارد.",
        status: "info",
        duration: 3000,
        isClosable: true,
        position: "top",
      });
      return;
    }

    const investPath = `/funds/${fundRegisterCode}/invest`;

    if (isAuthenticated) {
      navigate(investPath);
      return;
    }

    navigate(`/omidex?redirectTo=${encodeURIComponent(investPath)}`);
  };
};
